import React from 'react';

import Card from '../../../../../components/Card/index';

const ExperienceApproval = () => {
  return (
    <Card>
      <Card.Header>Your submitted experience hours are under review.</Card.Header>
      <Card.Body>
        You will be notified within 5 business days regarding next steps:
        <ol>
          <li>Submissions selected for audit will receive notification via email.</li>
          <div className="font-weight-bold">OR</div>
          <li>You will be prompted to complete the final certification steps.</li>
        </ol>
      </Card.Body>
    </Card>
  );
};

export default ExperienceApproval;
